import { register, defineRelation, Direction } from 'olympe';
import InspectionEntity from './InspectionEntity.js';
import Component from "./Component";
import Feedback from "./Feedback";
import Observation from "./Observation";

/**
 * @extends {InspectionEntity}
 */
export default class System extends InspectionEntity { /* empty */ }

// Hardcoded tags
register('01880fd02fdeecf26a89', System);
System.componentsRel = defineRelation('01880fd3ceeeeba6273b', System, Component);
System.feedbackRel = defineRelation('0188fc02f3398bf5257e', System, Feedback);
System.observationRel = defineRelation('0188fc071c22f0d611bd', System, Observation);
System.allComponentsRel = defineRelation('01898d9703ac827a5305', System, Component);
System.inverse_versionsystemRel = defineRelation('01880fd120ea5d1eca19', Direction.ORIGIN);
System.inverse_unitsystemsRel = defineRelation('0188d02e2563b9acabf3', Direction.ORIGIN);
